module.exports = __webpack_public_path__ + "img/bulk-def-no.5ab0142e.svg";